import { AssetsPage } from '@features/assets/components/AssetsPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/assets/monitors')({
    component: () => <AssetsPage kind="monitors" />,
    staticData: {
        crumb: {
            label: 'Monitors',
        },
    },
})
